import { useEffect } from "react";
import queryString from "query-string";
import { useAuthIssueAnonymousTokenByOTP } from "./useAuthIssueAnonymousTokenByOTP";
import { useToasts } from "react-toast-notifications";

export function useAuthIssueAnonymousTokenByOTPInURL() {
  const { addToast } = useToasts();
  const { issueAnonymousTokenByOTP } = useAuthIssueAnonymousTokenByOTP({
    onSuccess: () => {
      // Remove the OTP and identifier from the URL after successful verification
      const url = new URL(window.location.href);
      url.searchParams.delete("otp");
      url.searchParams.delete("identifier");
      url.searchParams.delete("type");
      window.history.replaceState({}, "", url.toString());

      addToast("One-time password verified successfully", {
        appearance: "success",
        autoDismiss: true,
      });
    },
    onError: (_, message) => {
      addToast(message, {
        appearance: "error",
        autoDismiss: true,
      });
    },
  });

  useEffect(() => {
    const query = queryString.parse(window.location.search);
    if (query.otp && query.identifier && query.type) {
      issueAnonymousTokenByOTP({
        otp: query.otp as string,
        identifier: query.identifier as string,
        type: query.type as "Email" | "Phone",
      });
    }
  }, [issueAnonymousTokenByOTP]);
}

export function buildReturnUrl(type: "Email" | "Phone", identifier: string) {
  const url = new URL(window.location.href);
  url.searchParams.set("type", type);
  url.searchParams.set("identifier", identifier);
  return url.toString();
}
